import api from '@/helpers/api'


const API_READ = `/api/transaction-report/`


export default {
  namespaced: true,
  state: {
    status: '',
    transactionReports: [],
    transactionDetail: null,
    detailLoading: false,
    meta: {
      page: 1,
      limit: 10,
      total: 1
    },
    filter: {}
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { transactionReports }) {
      state.transactionReports = [...transactionReports]
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta }
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
    reset_meta(state) {
      state.meta = {
        page: 1,
        limit: 10,
        total: 1
      };
    },
    set_transaction_detail(state, detail) {
      state.transactionDetail = detail;
    },
    set_detail_loading(state, loading) {
      state.detailLoading = loading;
    },
    // clear_meta(state) {
    //   state.meta = {
    //     page:1,
    //     limit:"10",
    //     total:1,
    //   };
    // },
    // set_search(state, { search }) {
    //   state.search = { ...search };
    // },
    // clear_search(state) {
    //   state.search = {};
    // },
  },
  actions: {
    read({ commit, state }) {
      commit('request');
      const { meta } = state
      const { filter } = state
      // const { search } = state

      return new Promise((resolve, reject) => {
        // api.request('get', API_READ, { meta, filter, search })
        api.request('get', API_READ, { meta, filter })
          .then((response) => {
            const transactionReports = response.data.data;

            commit('read', { transactionReports: transactionReports.data })
            commit('success')

            commit('switch_page', { meta: { ...transactionReports.meta } })
            return resolve(transactionReports)
          }).catch((err) => {
            commit('error')
            return reject(err)
          }).finally(() => {
          });
      })
    },
    export({ commit, state }) {
      commit('request');

      const { filter } = state
      const { search } = state
      const { sort } = state

      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ}export`, { filter, search, sort }, { responseType: 'blob' })
          .then((result) => {
            return resolve(result);
          }).catch(() => {
            return reject();
          });
      });
    },
    exportPdf({ commit, state }) {
      commit('request');

      const { filter } = state

      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ}export-pdf`, { filter }, { responseType: 'blob' })
          .then((result) => {
            commit('success');
            return resolve(result);
          }).catch(() => {
            commit('error');
            return reject();
          });
      });
    },
    exportWord({ commit, state }) {
      commit('request');

      const { filter } = state

      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ}export-word`, { filter }, { responseType: 'blob' })
          .then((result) => {
            commit('success');
            return resolve(result);
          }).catch(() => {
            commit('error');
            return reject();
          });
      });
    },
    readById({ commit }, id) {
      commit('set_detail_loading', true);

      return new Promise((resolve, reject) => {
        api.request('get', `${API_READ}${id}`)
          .then((response) => {
            const detail = response.data.data;
            commit('set_transaction_detail', detail);
            resolve(response);
          }).catch((err) => {
            reject(err);
          }).finally(() => {
            commit('set_detail_loading', false);
          });
      });
    },
  },
  getters: {
    transactionReports: () => state => state.transactionReports,
  }
}